import { createSignal } from "solid-js";
import { reportABug } from "../../services/settingsService";

export default function BugReport({ email }) {
  const [description, setDescription] = createSignal("");
  const [error, setError] = createSignal(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (description().length > 0) {
      const sendReport = await reportABug(email, description());
      if (sendReport !== true) {
        setError(-1);
      }
    } else {
      setError(-1);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <textarea
          class="bug-report-text-area"
          placeholder="Report a bug"
          onInput={(d) => {
            setError(0);
            setDescription(d.currentTarget.value);
          }}></textarea>
        <button class="button2" type="submit">
          Submit
        </button>
      </form>
      <Show when={error() === -1}>
        <p class="subtext" style="padding: 0; margin-bottom: 3px;">
          Something went wrong. Please try again later.
        </p>
      </Show>
    </div>
  );
}
